export default __webpack_public_path__ + "static/media/jellyfish.png";